








































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import moment from "moment";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import {
  SuketBaseWithRelationship,
  SuketKematianContentInterface
} from "@/types/suket_gawat_darurat";
import StoreSuketKematian from "@/store/modules/SuketKematian";
import SuketKematian from "@/services/SuketKematian";
// import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import SuketKematianInputCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketKematianInputCard.vue";
import { storePasien } from "@/store/modules/pasien";
import BaseCardSuket from "@/components/pemeriksaan/resumeSuketV2/BaseCardSuket.vue";
import { userModule } from "@/store/modules/user";

@Component({
  components: {
    CardModalTtd,
    BaseSuketCard,
    SuketKematianInputCard,
    BaseCardSuket
  },
  inject: {
    pageIsReadOnly: { from: "isReadOnly", default: () => () => false }
  }
})
export default class SuketKematianTabPage extends Vue {
  @Prop() readonly register!: string;
  @Prop({
    default: false
  })
  instantCreate: boolean;
  pageIsReadOnly!: () => boolean;

  expandInput = false;
  pageTab = "tab-soap";
  allowedUnit = ["*"];
  modalTtd = false;
  canInstantCreate = false;

  get dataSuket(): SuketBaseWithRelationship<SuketKematianContentInterface> {
    return StoreSuketKematian.suket;
  }

  get tglSurat() {
    return moment(this.dataSuket?.surat_date).format("DD-MM-YYYY");
  }

  get loadContent() {
    return StoreSuketKematian.loading;
  }

  get creatorUserId() {
    return this.dataSuket?.creator_user_id;
  }

  get signeeUserId() {
    return this.dataSuket?.signee_user_id;
  }

  get isReadOnly() {
    if (this.pageIsReadOnly()) return true;
    return (
      !this.allowedUnit.includes(userModule.user.unit_id) &&
      !this.allowedUnit.includes("*")
    );
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get deathAtFormated() {
    return this.dataSuket?.content?.death_at
      ? moment(this.dataSuket.content.death_at).format("DD-MM-YYYY HH:mm")
      : null;
  }

  get user() {
    return userModule.user;
  }

  get isCanCreate() {
    return true;
  }

  backPageSoap() {
    this.$emit("pageTab", this.pageTab);
  }

  print(id) {
    SuketKematian.print(id);
  }

  showInput() {
    this.expandInput = true;
  }

  closeInput() {
    this.expandInput = false;
    this.canInstantCreate = false;
  }

  showSignatureModal() {
    this.modalTtd = true;
  }

  passTtd(value) {
    appModule.setLoading(true);

    SuketKematian.sign(this.dataSuket.id, { password: value })
      .then(dt => {
        if (dt.status == 1) {
          appModule.NoticeDelay("Berhasil Tanda Tangan Surat Keterangan");
          appModule.addMsgTtd("");
          StoreSuketKematian.getSuketByRegister(this.register);
        } else {
          appModule.sendErrorAlert(dt.message);
        }
      })
      .finally(() => {
        appModule.setLoading(false);
        this.modalTtd = false;
      });
  }

  createSuketInstantly() {
    this.expandInput = true;

    this.$nextTick(() => {
      this.canInstantCreate = true;
    });
  }

  removeSuket() {
    appModule.setLoading(true);

    SuketKematian.destroy(this.dataSuket?.id)
      .then(dt => {
        if (dt.status == 1) {
          appModule.NoticeDelay(dt.message);
        }
      })
      .finally(() => {
        appModule.setLoading(false);

        StoreSuketKematian.getSuketByRegister(this.register);
      });
  }
}
